'use client';
import { useMemo } from 'react';

import { SemanticsExtended } from '@veneer/semantics';
import { ThemeProvider } from '@veneer/theme';

import { defaultThemeV2, themes } from './ThemeProviderWrapper.themes';

export default function ThemeProviderWrapperV2({
  children,
  shape = 'round',
  mode = 'light',
  theme,
}: Readonly<{
  children: React.ReactNode;
  shape?: 'sharp' | 'round';
  mode?: 'light' | 'dark';
  theme?: SemanticsExtended | string;
}>) {
  const getTheme = useMemo(() => {
    if (!theme) return defaultThemeV2;

    if (typeof theme === 'string') {
      theme = themes[theme];
    }

    return { ...defaultThemeV2, ...theme };
  }, [theme]);

  return (
    <ThemeProvider shape={shape} mode={mode} customSemantics={getTheme}>
      {children}
    </ThemeProvider>
  );
}
